/**
 * Copy-paste of generic template to make clear the purpose of this template (to render parcel information)
 * A sub-template (parcel-address-template) is used to render associated addresses 
 */

import Portal = require("portal-gis");
import _ = require("underscore");
import Utils = require("../utils");
import Services = require("../services/services");
import IPS = require("publicsector");
import $ = require("jquery");

function render(feature: Rhythm.GIS.FeatureQueryResultFeature, args: {
    symbol: Portal.MonikerSymbologyElement;
    layerOptions: Rhythm.GIS.Dictionary<string>;
    commands?: () => HTMLElement;
}) {
    let label = args.symbol ? _.template(args.symbol.Label)(feature.attributes) : "";

    let fieldList = args.layerOptions["field-list"] ? Utils.split(args.layerOptions["field-list"]) : [""];
    let showLabels = args.layerOptions["show-labels"] === "true";
    let fieldLabelMap = [];
    if (showLabels) {
        let fieldLabels = args.layerOptions["field-labels"] ? Utils.split(args.layerOptions["field-labels"]).map(v => v.trim()) : fieldList;
        fieldList.forEach((id, i) => fieldLabelMap[id] = fieldLabels[i]);
    }

    let keys = Object.keys(feature.attributes);

    let details = "";
    // preserves field order limited to valid keys
    if (Array.isArray(fieldList)) {

        let isVisible = d => typeof d in { string: 1, number: 1 };

        let doit = (showLoading = false) => {
            let fieldData = fieldList.map(k => ({ id: k, data: Utils.data(feature.attributes, k) }));
            details = fieldData
                .map(k => {
                    let visible = isVisible(k.data);
                    return `<tr class='${k.id} ${visible ? "" : showLoading ? "loading" : "hidden"}'><td><label class='name ${!showLabels ? "hidden" : ""}'>${fieldLabelMap[k.id] || k.id}</label></td><td><label class='value'>${visible ? k.data : ""}</label></td></tr>`;
                })
                .join('');

            let header = `<section class="header"><h3 class="project-title">${label}</h3></section>`;
            let body = `<section class="body"><table class='infoviewer-grid'><tbody>${details}</tbody></table></section>`;
            let footer = $(`<section class="footer"></section>`);
            if (args.commands) footer.append(args.commands());

            return $("<div>").append(header).append(body).append(footer);
        };
        return doit()[0];

    }

}


export = render;
